import { X } from "lucide-react";
import React from "react";

interface ThankyouProps {
    onClose: () => void;
}

const Thankyou: React.FC<ThankyouProps> = ({ onClose }) => {
    return (
        <>
            <div className="fixed inset-0 bg-black bg-opacity-50 z-[200] flex items-center px-4 justify-center">
                <div className="bg-white p-6 rounded-lg shadow-lg max-w-[500px] w-full text-center relative flex flex-col items-center justify-center">
                    <X
                        onClick={onClose}
                        className=" absolute top-4 right-4 cursor-pointer text-gray-400 hover:text-black transition-colors"
                    />
                    <h2 className="text-2xl font-bold mb-2">Order Complete 🎉</h2>
                    <p className="text-gray-700 mb-4">
                        Thank you for your purchase! <br />
                        We’ve received your order and it's now being processed.
                    </p>
                    <button
                        onClick={onClose}
                        className="mt-4 px-4 py-2 w-full bg-[#317333] text-white rounded hover:bg-green-700 transition-colors"
                    >
                        Close
                    </button>
                </div>
            </div>
        </>
    );
};

export default Thankyou;
